import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

export const PATHS = {
  dashboard: '/',
  auth: '/auth',
  elamaSignin: '/elama-signin',
  generator: 'generator',
  billing: '/billing',
};

export const SIDEBAR_ROUTES = [
  {
    id: 1,
    name: 'Шаблоны',
    path: PATHS.dashboard,
    icon: <GridViewRoundedIcon />,
  },
  {
    id: 2,
    name: 'Купить',
    path: PATHS.billing,
    icon: <AttachMoneyIcon />,
  },
];
